import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ReunionesService} from '../_services/reuniones.service';

@Component({
  selector: 'reunion-barra',
  standalone: false,
  templateUrl: 'reunion-barra.component.html'
})

export class ReunionBarraComponent implements OnInit, OnDestroy, AfterViewChecked {

  meetingType = 'Reunión no definida';
  meetingTitle = '';
  meetingDate = 'Sin definir';
  meetingTime = 'Sin definir';
  meetingDuration = '0';


  meetingServiceObs;

  constructor(private reunionesService: ReunionesService,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.meetingServiceObs = this.reunionesService.getObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.event === 'meeting-title') {
        this.meetingType = data.title;
        this.cdRef.detectChanges();
      }
      if (data.event === 'meeting-name') {
        this.meetingTitle = data.name;
        this.cdRef.detectChanges();
      }
      if (data.event === 'meeting-date') {
        this.meetingDate = data.date;
        this.cdRef.detectChanges();
      }
      if (data.event === 'meeting-time') {
        this.meetingTime = data.time;
        this.cdRef.detectChanges();
      }
      if (data.event === 'meeting-duration') {
        this.meetingDuration = data.duration;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.meetingServiceObs) {
      this.meetingServiceObs.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
}
